import { registerCustomControlProvider } from '../registry';
import {
  createAiButton,
  createToolsButton,
  createAdjustmentsButton,
  buildObjectActionsButtons,
} from './shared';
import { prepareAddMagicFrameFromImage } from '~core/magicFrame';
import { fetchAiCredits } from '~graphql/controllers';

registerCustomControlProvider({
  id: 'image-floating-controls',
  match: (object) => object && object.type === 'image' && !object._magicFrame,
  create: (manager, image) => {
    const options = {
      offsetY: 0,
      offsetX: 0,
      gap: 12,
      initialView: 'home',
      views: {
        home: {
          buttons: [
            createAiButton(() => image),
            {
              text: 'Aggiungi Cornice',
              icon: '🖼️',
              className: 'btn-customize-frame',
              onClick: () => {
                try {
                  prepareAddMagicFrameFromImage(image);
                } catch (e) {
                  console.error('Impossibile avviare Aggiungi Cornice', e);
                }
              },
            },
            createToolsButton(() => image),
            createAdjustmentsButton(() => image),
            { type: 'divider' },
            {
              text: 'Azioni',
              inlineSvg:
                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"></path></svg>',
              className: 'btn-customize',
              children: buildObjectActionsButtons(() => image),
            },
          ],
        },
      },
    };

    const ctrl = manager.createFloatingControls(image, options);

    const updateAiCreditsLabel = async () => {
      try {
        const credits = await fetchAiCredits();
        const total =
          (credits?.edges?.[0]?.freeCreditsAmount || 0) +
          (credits?.edges?.[0]?.paidCreditsAmount || 0);
        const btn = ctrl?.element?.querySelector(
          '.btn-ai-credits .button-text'
        );
        if (btn) btn.textContent = `Crediti (${total})`;
      } catch (e) {
        console.error('Failed updating AI credits label (image control)', e);
      }
    };

    // Initial update shortly after mount
    setTimeout(updateAiCreditsLabel, 0);

    // Update whenever control is shown again
    if (ctrl && typeof ctrl.show === 'function') {
      const originalShow = ctrl.show.bind(ctrl);
      ctrl.show = () => {
        originalShow();
        updateAiCreditsLabel();
      };
    }

    return ctrl;
  },
});
